// Shared keys for the impersonation handshake. Writer (MagicLoginRedeem) and
// readers (ImpersonationChrome, write-guard) MUST agree on these strings.
export const IMPERSONATION_FLAG_KEY = "pubrio-impersonation-state";
export const IMPERSONATION_WRITE_ACK_KEY = "pubrio-impersonation-write-ack";
// `storage` events don't fire in the same tab — banner uses this for in-tab sync.
export const IMPERSONATION_CHANGED_EVENT = "pubrio-impersonation-changed";
